import { ContentHeaderDirectiveModule } from '@b2b/common/directives';
import { LoadCssResolver, LoadScriptResolver, PrinterDataResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { FormsPreviewControllerModule } from './controllers/FormsPreviewController';

export const FormsPreviewView = angular
  .module('acme.view.application.forms.preview', [
    uiRouter,
    'ui.bootstrap',
    ContentHeaderDirectiveModule,
    FormsPreviewControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    $stateProvider.state({
      name: 'application.forms.preview',
      url: '/preview',
      abstract: true,
      views: {
        'main@': {
          controller: 'FormsPreviewController',
          templateUrl: 'layouts/minimal.tpl.html',
        },
      },
      data: {
        pageTitle: 'Form Preview',
        /** Secure With Permissions **/
        permissions: ['FORMS_VIEW'],
      },
    });

    $stateProvider.state({
      name: 'application.forms.preview.default',
      url: '/:formId?eventName&eventStartTime&eventEndTime',
      views: {
        'subview-main': {
          templateUrl: 'views/application/views/forms/preview/preview.tpl.html',
        },
      },
      resolve: {
        formRender: LoadScriptResolver({ id: 'form-render-js', url: '/assets/form-render.min.js' }),
        formRenderCss: LoadCssResolver({ id: 'form-render', url: '/assets/form-render.min.css' }),
        PrinterData: PrinterDataResolver(),
      },
    });
  }).name;
